import { motion } from 'motion/react';
import FullMono from '~/brand/generated/propfit.app/FullMono';
import { useBrandName } from '~/brand/BrandContext';

interface WelcomeScreenProps {
  onGetStarted: () => void;
}

export function WelcomeScreen({ onGetStarted }: WelcomeScreenProps) {
  const brandName = useBrandName();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#00B3B3] to-[#157DA6] p-6 text-white'
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className='space-y-8 text-center'
      >
        <div className='mx-auto flex justify-center'>
          <FullMono className='h-auto w-44' />
        </div>

        <div className='space-y-4'>
          <h1 className='text-4xl'>Welcome to {brandName}</h1>
          <p className='mx-auto max-w-md text-xl opacity-90'>
            The smart way to manage your assets and optimize operations
          </p>
        </div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
          className='space-y-4'
        >
          <button
            onClick={onGetStarted}
            type='button'
            className='rounded-xl bg-white px-4 py-3 text-lg text-[#238080] transition-all duration-200 hover:scale-105 hover:shadow-md focus:scale-95'
          >
            Get Started
          </button>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className='space-y-4'
        >
          <p className='text-sm opacity-75'>
            Set up your business in just a few minutes
          </p>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}
